import * as React from "react";
import { Info } from "lucide-react";
import { LegendEntryComponent } from "../../components/ui/legendEntryComponent";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from "../../components/ui/tooltip";
import { transformToDefaultValue, useDynamicLegend } from "./legend";
function formatYValue(yValue, seriesEntry) {
    const type = seriesEntry.details.yValueFormat;
    switch (type) {
        case "rounded":
            return Math.floor(yValue).toLocaleString("de-DE");
        case "oneDecimalPlace":
            return yValue.toLocaleString("de-DE", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
        case "twoDecimalPlaces":
            return yValue.toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        default:
            return Math.floor(yValue).toLocaleString("de-DE");
    }
}
const StaticTimeSeriesLegendEntryContainer = ({ series, entry, name, visible, onToggle, }) => {
    return (React.createElement(LegendEntryComponent, { xValue: entry.formattedXValue, yValue: entry.formattedYValue, color: series.color, name: name, mode: "show", extension: entry.extension, unit: entry.unit, visible: visible, onToggle: onToggle }));
};
const DynamicTimeSeriesLegendEntryContainer = ({ chartDivId, time, series, entry, name, visible, onToggle, }) => {
    const defaultValues = transformToDefaultValue(series.key, series.seriesEntry, time);
    const values = useDynamicLegend(chartDivId, defaultValues, (values) => values.key === series.key, (values) => formatYValue(values.yValue, series.seriesEntry));
    return (React.createElement(LegendEntryComponent, Object.assign({}, values, { color: series.color, name: name, mode: "optional", extension: entry.extension, unit: entry.unit, visible: visible, onToggle: onToggle })));
};
const TimeSeriesLegendEntryContainer = ({ chartDivId, series, entry, name, time, visible, onToggle, }) => {
    if (entry.formattedXValue && entry.formattedYValue) {
        return (React.createElement(StaticTimeSeriesLegendEntryContainer, { series: series, entry: entry, name: name, visible: visible, onToggle: onToggle }));
    }
    else {
        return (React.createElement(DynamicTimeSeriesLegendEntryContainer, { chartDivId: chartDivId, time: time, series: series, entry: entry, name: name, visible: visible, onToggle: onToggle }));
    }
};
export const LegendEntryContainer = ({ chartDivId, series, entry, onToggle, visible, time, }) => {
    if ("node" in entry && entry.node) {
        // Variant (-> custom)
        return entry.node;
    }
    let name = null;
    if ("description" in entry && entry.description) {
        // Variant (-> restriction group / swimlane)
        name = (React.createElement(TooltipProvider, null,
            React.createElement(Tooltip, null,
                React.createElement(TooltipTrigger, { asChild: true }, entry.icon || React.createElement(Info, { className: "p-1" })),
                React.createElement(TooltipContent, null,
                    React.createElement("p", null, entry.description)))));
    }
    else if ("name" in entry) {
        // Variant (-> time series)
        name = entry.name;
    }
    if (name) {
        return (React.createElement(TimeSeriesLegendEntryContainer, { chartDivId: chartDivId, name: name, entry: entry, series: series, onToggle: onToggle, visible: visible, time: time }));
    }
    // all others already handled or invalid
    return null;
};
//# sourceMappingURL=LegendEntryContainer.js.map